export default __webpack_public_path__ + "static/media/hotei16.107f2695.webp";